import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import "./style.scss";

function ButtonComponent({
  variant,
  onClick,
  disabled,
  children,
  title,
  className = "",
  ...props
}) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={`btn-custom waves-effect btn-light w-100 mb-2 ${className}`}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children ? children : t(title)}
    </button>
  );
}

export default memo(ButtonComponent);
